import { render, staticRenderFns } from "./TelefonosView.vue?vue&type=template&id=154e6192"
import script from "./TelefonosView.vue?vue&type=script&lang=ts"
export * from "./TelefonosView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports